import modal from './modal-view'

export default modal
